var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-qr',{attrs:{"text":_vm.downloadData.url,"margin":10,"colorDark":"#000","colorLight":"#fff","dotScale":1,"logoSrc":_vm.downloadData.icon,"logoScale":0.2,"size":140}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79377914","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/h-qr-code.vue
// module id = null
// module chunks = 